import { ControlListProps, useRuntimeEnv, useTranslations } from "@harea/component";

const PERSONNELS_GQL = `
  query GetPersonnels($data: JSONObject) {
    personnels(filter: { data: $data }) {
      data {
        id
        fullName
        matricule
        profilePicture { id }
      }
    }
  }
`;

export function useCreateDebauchageFormStep1(): ControlListProps {
  const { runtimeEnv } = useRuntimeEnv(true);
  const [
    DEPARTURE_TYPE,
    EFFECTIVE_DATE,
    REASON,
    EMPLOYEE,
    ,
    ,
    ,
    RESIGNATION,
    MISCONDUCT,
    SERIOUS_MISCONDUCT,
    CONTRACT_END,
    NEGOTIATED_RESIGNATION,
  ] = useTranslations(i18n);

  return {
    data: {
      forms: [
        {
          type: "select",
          name: "personnel",
          label: EMPLOYEE,
          valueObject: true,
          GQLProps: {
            gql: PERSONNELS_GQL,
            variables: {
              data: {
                organisation: {
                  id: runtimeEnv?.organisation?.id,
                },
              },
            },
            rootProp: "personnels.data",
            labelProp: "fullName",
            valueProp: "id",
          },
          required: true,
        },
        {
          type: "select",
          name: "departureType",
          label: DEPARTURE_TYPE,
          options: [
            { value: "RESIGNATION", label: RESIGNATION },
            { value: "MISCONDUCT", label: MISCONDUCT },
            { value: "SERIOUS_MISCONDUCT", label: SERIOUS_MISCONDUCT },
            { value: "CONTRACT_END", label: CONTRACT_END },
            { value: "NEGOTIATED_RESIGNATION", label: NEGOTIATED_RESIGNATION },
          ],
          required: true,
        },
        {
          type: "date-picker",
          name: "effectiveDate",
          label: EFFECTIVE_DATE,
          required: true,
        },
        {
          type: "text-area",
          name: "reason",
          label: REASON,
          required: false,
        },
      ],
    },
  };
}

export function useCreateDebauchageFormStep2(): ControlListProps {
  const [
    ,
    ,
    ,
    ,
    RESIGNATION_LETTER,
    DISMISSAL_PV,
    SOLDE_DE_TOUT_COMPTE,
  ] = useTranslations(i18n);

  return {
    data: {
      forms: [
        {
          type: "file",
          name: "resignationLetter",
          label: RESIGNATION_LETTER || "Lettre de démission",
          required: false,
        },
        {
          type: "file",
          name: "dismissalPV",
          label: DISMISSAL_PV || "PV de licenciement",
          required: false,
        },
        {
          type: "file",
          name: "soldeDeToutCompte",
          label: SOLDE_DE_TOUT_COMPTE || "Solde de tout compte",
          required: false,
        },
      ],
    },
  };
}

const i18n = [
  "std_departure_type",
  "std_effective_date",
  "std_reason",
  "std_employee",
  "std_resignation_letter",
  "std_dismissal_pv",
  "std_solde_de_tout_compte",
  "std_resignation",
  "std_misconduct",
  "std_serious_misconduct",
  "std_contract_end",
  "std_negotiated_resignation",
];
